import { isPreviousThreeLineIndustryHeading } from './landingEditorIndustryThreeLineHeadingsMigration.js';
import { isPreviousCompanyIndustryHeading } from './landingEditorCompanyIndustryHeroMigration.js';
import type { StaticPageAudience } from '../content/staticPageContent.js';
import { isIndustryPageKey } from '../content/industryPages.js';

// Refresh only recognized shipped headings; editorial copy remains untouched.
const previousDefaultHeadings = new Set([
  "Dein Können. Neue Verbindungen.",
  "Baue an deiner Zukunft in Deutschland.",
  "Dein Handwerk verbindet.",
  "Präzision im Beruf. Perspektive für dich.",
  "Dein Können für moderne Gebäudetechnik.",
  "Bring deine Zukunft auf die Straße.",
  "Your skills. New connections.",
  "Build your future in Germany.",
  "Your craft makes connections.",
  "Precision at work. A future for you.",
  "Your skills for modern building services.",
  "Take your future on the road.",
  "Becerilerinle yeni bağlantılar kur.",
  "Almanya’da geleceğini inşa et.",
  "Ustalığınla sağlam bağlar kur.",
  "İşinde hassasiyet. Geleceğinde yeni bir adım.",
  "Modern bina teknolojileri için becerilerin.",
  "Geleceğini yola çıkar.",
  "Service, Frische und Kundennähe.",
  "Menschen, die Märkte stärken.",
  "Hizmet, tazelik ve müşteri yakınlığı.",
  "Mağazaları güçlendiren insanlar.",
  "Service, fresh goods and customer closeness.",
]);

const previousCareHeadings = new Set([
  'Pflegekräfte, die in Deutschland ankommen.',
  'Pflegekräfte gewinnen, die bleiben.',
  'Almanya’da bakım alanında güvenle başla.',
  'Kalıcı olacak bakım çalışanları kazanın.',
  'Start your care career in Germany with confidence.',
  'Hire care professionals who stay.',
]);

export const industryHeroHeading = (
  pageKey: string,
  title: string,
  defaultTitle: string,
  contentRevision: number,
  audience?: StaticPageAudience,
): string =>
  ((contentRevision < 23 && isIndustryPageKey(pageKey) && previousDefaultHeadings.has(title)) ||
    (contentRevision < 24 && pageKey === 'pflege' && previousCareHeadings.has(title)) ||
    (contentRevision < 26 && audience === 'company' && isPreviousCompanyIndustryHeading(pageKey, title)) ||
    (contentRevision < 27 && isPreviousThreeLineIndustryHeading(pageKey, title, audience ?? 'applicant')))
    ? defaultTitle
    : title;
